import { request } from './helpers/request'

export default () =>
  request({
    url: '/users/mfa/totp/register',
    method: 'GET'
  }).then(response => {
    return response.json().then(json => {
      if (response.status === 200) {
        return Promise.resolve(json)
      } else {
        return Promise.reject(new Error(json.code))
      }
    })
  })
